import './CarModelBookTestDrive.scss';
import Button from '../../ui/Button/Button';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

export default function CarModelBookTestDrive({ fields }) {
  return (
    <div className={'container car-model-test-drive'}>
      <div className={'wrapper'} data-aos="fade-up">
        <h3 className={'title'}>
          <RichText field={fields?.text} />
        </h3>
        <a
          href={`${fields?.buttonUrl?.value?.href || ''}${
            fields?.buttonUrl?.value?.querystring || ''
          }`}
        >
          <Button className={'button'} isShowTooltip={false}>
            {fields?.buttonText?.value}
          </Button>
        </a>
      </div>
    </div>
  );
}
